<app-breadcrumb [title]="'Generar Certificados GPS'" [items]="['Vehiculos']" [active_item]="'Certificados GPS'"></app-breadcrumb>

<div class="container-fluid">
  <div class="row justify-content-center">
    <div class="col-12 ">
      <div class="card-header d-flex align-items-center justify-content-between"
      style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 1.25rem;">
      <div class="d-flex align-items-center text-white">
        <div class="bg-white bg-opacity-25 rounded-circle p-2 me-3"
          style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center;">
          <i class="icofont icofont-chart-line" style="font-size: 1.8rem; color: white;"></i>
        </div>
        <div>
          <h4 class="mb-0 fw-bold">GENERAR CERTIFICADO GPS</h4>
          <small class="opacity-75">Generar certificado GPS disponibles</small>
        </div>
      </div>
      <div class="text-white d-none d-md-block">
       <img src="assets/images/logo/logo-indesoft.png" alt="Reportes Icon" style="height:60px;">
      </div>
    </div>
      <div class="card shadow-lg">
        <div class="card-body">
          <!-- Aquí puedes agregar el contenido del formulario o la funcionalidad para generar certificados GPS -->
           
        <div class="card-body">
         <div class="gps-info-alert">
  <div class="gps-info-icon">
    <i class="icofont icofont-info-circle"></i>
  </div>

  <div class="gps-info-content">
    <div class="gps-info-heading">
      <strong>Generación de certificados GPS</strong>
      <span class="gps-limit-badge">Máximo 10 placas</span>
    </div>

    <p>
      Selecciona los vehículos que deseas incluir en el certificado.
      Validaremos que cada placa exista y esté activa en la plataforma GPS.
      Todas las placas seleccionadas se incluirán en un único certificado.
    </p>
  </div>
</div>
          <div class="row">
            <div class="col-12 col-md-6">
              <label for="placa" class="form-label text-dark">
                Placas <span class="text-danger">*</span>
                <span *ngIf="placasSeleccionadas.length" class="badge bg-primary ms-1">{{ placasSeleccionadas.length }}</span>
              </label>
              <ng-select
                id="placa"
                [items]="vehiculos"
                bindLabel="name"
                bindValue="name"
                [multiple]="true"
                [closeOnSelect]="false"
                [(ngModel)]="placasSeleccionadas"
                [loading]="cargandoVehiculos"
                [disabled]="generando"
                placeholder="Seleccionar placas"
                [maxSelectedItems]="10"
                notFoundText="No hay placas"
                loadingText="Cargando placas...">
              </ng-select>
            </div>
          </div>

          <p *ngIf="generando && progreso" class="text-muted mt-3 mb-0">
            <span class="spinner-border spinner-border-sm me-2"></span>{{ progreso }}
          </p>
        </div>

        <div class="card-footer d-grid d-md-block">
          <button type="button" class="btn btn-primary" (click)="generarCertificado()"
                  [disabled]="!placasSeleccionadas.length || generando || cargandoVehiculos">
            <span *ngIf="generando" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!generando" class="icofont icofont-file-pdf me-1"></i>
            <strong>GENERAR CERTIFICADO</strong>
          </button>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>